import { render, staticRenderFns } from "./OfficialQrCode.vue?vue&type=template&id=736814f5&scoped=true&"
import script from "./OfficialQrCode.vue?vue&type=script&lang=js&"
export * from "./OfficialQrCode.vue?vue&type=script&lang=js&"
import style0 from "./OfficialQrCode.vue?vue&type=style&index=0&id=736814f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736814f5",
  null
  
)

export default component.exports